import { render, staticRenderFns } from "./StickerChatContent.vue?vue&type=template&id=813c19aa"
import script from "./StickerChatContent.vue?vue&type=script&lang=js"
export * from "./StickerChatContent.vue?vue&type=script&lang=js"
import style0 from "./StickerChatContent.vue?vue&type=style&index=0&id=813c19aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports